import { type MetaFunction } from '@remix-run/node'
import admiral from './admiral.png'

export const meta: MetaFunction = () => [
	{ title: 'Admiral Insurance Group' },
	{
		name: 'description',
		content: 'Admiral Insurance Group',
	},
]
export default function Component() {
	return (
		<main className="mx-auto my-10 max-w-7xl">
			<h1 className="py-3 text-4xl font-black">Admiral Insurance Group</h1>

			<img src={admiral} alt="Admiral Insurance Group" className="w-64" />

			<section>
				<h3>Home Office Address</h3>

				<p
					data-paragraph
					className="mt-6 text-xl/7 text-muted-foreground xl:mt-8 xl:text-xl/6 xl:leading-10"
				>
					Admiral Insurance Group
					<br />
					1000 Howard Boulevard
					<br />
					Suite 300
					<br />
					Mount Laurel, NJ 08054
				</p>
			</section>
		</main>
	)
}
